import { render, staticRenderFns } from "./EstruturaItem.vue?vue&type=template&id=310a1a50"
import script from "./EstruturaItem.vue?vue&type=script&lang=js"
export * from "./EstruturaItem.vue?vue&type=script&lang=js"
import style0 from "./EstruturaItem.vue?vue&type=style&index=0&id=310a1a50&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports